import { MenuItem, VueRouter } from "@abaco/web-common/src/app";

export function createMenu(router: VueRouter): MenuItem[] {
    return [];
}
